export default function ClientBranding() {
  return (
    <section className="flex flex-col gap-4 align-middle items-center">
      <h1>Branding Page</h1>
      <p>Coming Soon</p>
    </section>
  );
}
